export default __webpack_public_path__ + "locales/it/VersionHistory.json?hash=d0a96c186c5e21b79f12ab1a0bbdfc9d";